import React from 'react';
import styled from '@emotion/styled';
import { Container } from '@mui/material';
import MText from '../../components/common/MText';

function IntroductionArea({ backgroundImgSrc, introductionText, introductionSubText }) {
  const iconImgs = [];
  for (let i = 1; i <= 6; i += 1) {
    iconImgs.push({ name: `${i}` });
  }

  return (
    <Container
      sx={{
        textAlign: 'center',
        paddingTop: '160px',
        background: `url(${backgroundImgSrc}) no-repeat bottom center`,
        paddingBottom: '360px',
      }}
    >
      <Section>
        <MText>{introductionText}</MText>
        <MText style={{ marginTop: '20px', color: '#fff', fontWeight: '300' }}>{introductionSubText}</MText>
      </Section>
      <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingTop: '60px' }}>
        {iconImgs.map((icon) => (
          <img key={icon.name} src={`/images/guide/img_product${icon.name}.png`} alt={`product${icon.name}`} />
        ))}
      </div>
    </Container>
  );
}

const Section = styled.section`
  color: #fff;
  h1 {
    font-weight: 500;
    font-size: 3.4rem;
  }

  h3 {
    margin-top: 20px;
    font-weight: 300;
  }
`;

export default IntroductionArea;
